import { put } from "redux-saga/effects";

export function* handleError(actionType, msg) {
    yield put(actionType(msg))
}